import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaults = {
  adminUrl: '',
  countries: [],
  currency: {
    code: 'USD',
    precision: 2,
    symbol: '$',
    symbolPosition: 'left',
    decimalSeparator: '.',
    priceFormat: '%1$s%2$s',
    thousandSeparator: ','
  },
  defaultDateRange: 'period=month&compare=previous_year',
  locale: {
    siteLocale: 'en_US',
    userLocale: 'en_US',
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  },
  orderStatuses: [],
  siteTitle: '',
  wcAssetUrl: ''
};
var globalSharedSettings = (typeof wcSharedSettings === "undefined" ? "undefined" : _typeof(wcSharedSettings)) === 'object' ? wcSharedSettings : {}; // Use defaults or global settings, depending on what is set.

var allSettings = _objectSpread({}, defaults, {}, globalSharedSettings);

allSettings.currency = _objectSpread({}, defaults.currency, {}, allSettings.currency);
allSettings.locale = _objectSpread({}, defaults.locale, {}, allSettings.locale);
export var ADMIN_URL = allSettings.adminUrl;
export var COUNTRIES = allSettings.countries;
export var CURRENCY = allSettings.currency;
export var LOCALE = allSettings.locale;
export var ORDER_STATUSES = allSettings.orderStatuses;
export var SITE_TITLE = allSettings.siteTitle;
export var WC_ASSET_URL = allSettings.wcAssetUrl;
export var DEFAULT_DATE_RANGE = allSettings.defaultDateRange;
export function getSetting(name) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allSettings.hasOwnProperty(name)) {
    return allSettings[name];
  }

  return fallback;
}
//# sourceMappingURL=index.js.map